import { Reducer } from 'redux'
import {
  RevenueMiscellaneousActionTypes,
  type RevenueDisbursementSidePanel,
  type RevenueDisbursementSidePanelAction,
  initialRevenueDisbursementSidePanelState,
} from './types'

export * from './types'

export const reducer: Reducer<
  RevenueDisbursementSidePanel,
  RevenueDisbursementSidePanelAction
> = (state = initialRevenueDisbursementSidePanelState, action) => {
  switch (action.type) {
    case RevenueMiscellaneousActionTypes.SET_DISBURSEMENT_START_END_DATE: {
      return {
        ...state,
        startDateOfMonth: action.payload.startDate,
        endDateOfMonth: action.payload.endDate,
      }
    }
    case RevenueMiscellaneousActionTypes.SET_REQUEST_PROCESSED_DATE: {
      return {
        ...state,
        requestedForDatetime: action.payload,
      }
    }
    case RevenueMiscellaneousActionTypes.SET_SETTLEMENT_ID: {
      return {
        ...state,
        settlementId: action.payload,
      }
    }
    case RevenueMiscellaneousActionTypes.SET_DISBURSEMENT_SIDE_PANEL_LOADING: {
      return {
        ...state,
        disbursementSidePanelLoading: action.payload
          ? state.disbursementSidePanelLoading + 1
          : state.disbursementSidePanelLoading - 1,
      }
    }
    default: {
      return state
    }
  }
}
